import { render, staticRenderFns } from "./ListPriceList.vue?vue&type=template&id=27d220f8&"
import script from "./ListPriceList.vue?vue&type=script&lang=js&"
export * from "./ListPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports